import { DEFAULT_BINGO_SETTINGS, getBingoCategory, type RoomSettings } from "@hitster/shared";

interface Props {
  settings: RoomSettings;
}

export function RoomSettingsSummary({ settings }: Props) {
  const gameKind = settings.gameKind ?? "timeline";
  if (gameKind === "bingo") {
    const bingo = { ...DEFAULT_BINGO_SETTINGS, ...settings.bingo };
    const names = bingo.categories.map((id) => {
      try {
        return getBingoCategory(id).name;
      } catch {
        return id;
      }
    });
    const win = [
      bingo.winConditions.horizontal ? "lignes" : null,
      bingo.winConditions.vertical ? "colonnes" : null,
      bingo.winConditions.diagonal ? "diagonales" : null,
    ].filter(Boolean);
    return (
      <div className="text-sm space-y-1 text-violet-300/80">
        <p>Mode : 🎱 Bingo</p>
        <p>Grille : {bingo.gridSize}×{bingo.gridSize}</p>
        <p>Timer : {bingo.timerSeconds === null ? "illimité" : `${bingo.timerSeconds}s`}</p>
        <p>Victoire : {win.join(", ") || "—"}</p>
        <p>Pouvoir année exacte : {bingo.exactYearPower ? "oui" : "non"}</p>
        <p>Catégories : {names.join(", ")}</p>
      </div>
    );
  }

  return (
    <div className="text-sm space-y-1 text-violet-300/80">
      <p>Mode : 🕰️ Frise {settings.mode === "shared" ? "commune" : "individuelle"}</p>
      <p>Objectif : {settings.winTarget} cartes</p>
      <p>Durée manche : {settings.roundDurationSeconds}s</p>
      <p>Écoute : {settings.singleListen ? "unique" : "répétable"}</p>
      <p>
        Après victoire :{" "}
        {settings.continueAfterWin !== false ? "les autres peuvent continuer" : "fin de partie"}
      </p>
      <p>
        Indices :{" "}
        {settings.hintsEnabled
          ? `activés (${settings.maxHintsPerPlayer ?? 3} max / joueur)`
          : "désactivés"}
      </p>
    </div>
  );
}
